import { get, post } from '../../common/httpService';

const getFeedbacks = (page = 0, sortType = 1) => {
    return get({
        url: `Feedback/FeedbacksJson?p=${page}&t=${sortType}`,
    });
};

const reportFeedbackAbuse = (feedbackId, type) => {
    return post({
        url: `Feedback/UserReportAbuse/${feedbackId}`,
        body: type,
    });
};

export { getFeedbacks, reportFeedbackAbuse };
